import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
// import vueResource from 'vue-resource'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false
Vue.use(VueSweetalert2)
Vue.use(BootstrapVue)
// Vue.use(vueResource)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = 'https://kopiraittila.fi/wp-json/wp/v2/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js